import React from "react";
import ContentLoader from "react-content-loader";
import { Row, Col } from "reactstrap";
import { Card } from 'reactstrap';
const AvailableProjectsLoader = ({ count = 8 }) => {
  return (
    <Row>
      {[...Array(count)].map((_, index) => (
        <Col key={index} sm="6" lg="4" className="mt-4">
          <div className="ebw-card__wrap ebw-card__wrap--secondary">
            <Card className="ebw-card ebw-card__secondary">
              <ContentLoader
                speed={2}
                width="100%"
                height={250}
                viewBox="0 0 400 250"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
              >
                <rect x="0" y="0" rx="10" ry="10" width="400" height="140" />
                <rect x="15" y="160" rx="4" ry="4" width="210" height="16" />
                <rect x="15" y="184" rx="4" ry="4" width="150" height="12" />
                <rect x="305" y="160" rx="4" ry="4" width="75" height="12" />
                <rect x="305" y="182" rx="4" ry="4" width="75" height="12" />
              </ContentLoader>
            </Card>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default AvailableProjectsLoader;
